module.exports = __webpack_public_path__ + "img/matterfi.dfd80ccb.svg";